import type { ReactiveDataDocument } from '@warp-drive/core/reactive';

/**
 * Extracts the total count from a pagination metadata object.
 *
 * @param page - The pagination metadata object from a JSON:API response
 * @returns The total count, or 0 if not found
 */
export function getPaginationTotal(
  response: ReactiveDataDocument<unknown>
): number {
  if (
    typeof response.meta?.page === 'object' &&
    response.meta.page !== null &&
    'total' in response.meta.page
  ) {
    return response.meta.page.total as number;
  }
  return 0;
}
